export default __webpack_public_path__ + "static/media/LuckyYou Logo.7cead70c.png";